export const transitControlTags = ['TransitControl'] as const;
